module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_04-6f605c689a595da76587d0767ca8d1f6.webp";